import styled from 'styled-components';
import {
  FilterOption1,
  FilterOption2,
  FilterOption3,
} from '../search/FilterData';
import { useState } from 'react';

interface Props {
  filters: {
    category: string[];
    region: string[];
    itemType: string[];
  };
  setFilters: (filters: any) => void;
}

const BondFilter = ({ filters, setFilters }: Props) => {
  const [tempFilters, setTempFilters] = useState(filters);
  const allSelected1 = FilterOption1.every((item) =>
    tempFilters.category.includes(item.name),
  );
  const allSelected2 = FilterOption2.every((item) =>
    tempFilters.region.includes(item.name),
  );
  const allSelected3 = FilterOption3.every((item) =>
    tempFilters.itemType.includes(item.name),
  );

  const handleResetOption = () => {
    setFilters({ category: [], region: [], itemType: [] });
  };

  return (
    <Container>
      <FilterWrapper>
        <FilterOptionBox>
          <span>채권종류</span>
          <FilterOption>
            <OptionItem
              onClick={() => {
                allSelected1
                  ? setTempFilters({ ...tempFilters, category: [] })
                  : setTempFilters({
                      ...tempFilters,
                      category: FilterOption1.map((item) => item.name),
                    });
              }}
            >
              <img
                src={`/assets/images/check/${allSelected1 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>채권종류 전체</span>
            </OptionItem>
            {FilterOption1.map((item, index) => (
              <OptionItem
                key={index}
                onClick={() => {
                  const updatedCategory = tempFilters.category.includes(
                    item.name,
                  )
                    ? tempFilters.category.filter((name) => name !== item.name)
                    : [...tempFilters.category, item.name];

                  setTempFilters({ ...tempFilters, category: updatedCategory });
                }}
              >
                <img
                  src={`/assets/images/check/${
                    tempFilters.category.includes(item.name)
                      ? 'check-blue-on'
                      : 'check-blue-off'
                  }.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </FilterOption>
        </FilterOptionBox>
        <FilterOptionBox>
          <span>지역분류</span>
          <FilterOption>
            <OptionItem
              onClick={() => {
                allSelected2
                  ? setTempFilters({ ...tempFilters, region: [] })
                  : setTempFilters({
                      ...tempFilters,
                      region: FilterOption2.map((item) => item.name),
                    });
              }}
            >
              <img
                src={`/assets/images/check/${allSelected2 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>지역분류 전체</span>
            </OptionItem>
            {FilterOption2.map((item, index) => (
              <OptionItem
                key={index}
                onClick={() => {
                  const updatedRegion = tempFilters.region.includes(item.name)
                    ? tempFilters.region.filter((name) => name !== item.name)
                    : [...tempFilters.region, item.name];

                  setTempFilters({ ...tempFilters, region: updatedRegion });
                }}
              >
                <img
                  src={`/assets/images/check/${tempFilters.region.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </FilterOption>
        </FilterOptionBox>
        <FilterOptionBox>
          <span>물건종류</span>
          <FilterOption>
            <OptionItem
              onClick={() => {
                allSelected3
                  ? setTempFilters({ ...tempFilters, itemType: [] })
                  : setTempFilters({
                      ...tempFilters,
                      itemType: FilterOption3.map((item) => item.name),
                    });
              }}
            >
              <img
                src={`/assets/images/check/${allSelected3 ? 'check-blue-on' : 'check-blue-off'}.svg`}
                alt="Check"
              />
              <span>물건종류 전체</span>
            </OptionItem>
            {FilterOption3.map((item, index) => (
              <OptionItem
                key={index}
                onClick={() => {
                  const updatedItemType = tempFilters.itemType.includes(
                    item.name,
                  )
                    ? tempFilters.itemType.filter((name) => name !== item.name)
                    : [...tempFilters.itemType, item.name];

                  setTempFilters({ ...tempFilters, itemType: updatedItemType });
                }}
              >
                <img
                  src={`/assets/images/check/${tempFilters.itemType.includes(item.name) ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{item.name}</span>
              </OptionItem>
            ))}
          </FilterOption>
        </FilterOptionBox>
      </FilterWrapper>
      <ButtonBox>
        <ResetButton onClick={handleResetOption}>
          <img src="/assets/images/icon/reset.svg" alt="" />
          <span>초기화</span>
        </ResetButton>
        <ApplyButton
          onClick={() => {
            setFilters(tempFilters);
          }}
        >
          검색
        </ApplyButton>
      </ButtonBox>
    </Container>
  );
};
export default BondFilter;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const ResetButton = styled.button`
  width: 57px;
  height: 41px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  background-color: #fff;
  font-size: 12px;
  font-weight: 400;
  color: #616161;
  cursor: pointer;
`;
const ApplyButton = styled.button`
  flex: 1;
  height: 41px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: none;
  background-color: #008aff;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
`;

const FilterWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
`;

const Container = styled.div`
  width: 100%;
  padding: 24px 16px 42px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FilterOptionBox = styled.div`
  width: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 1px solid #e5e8ea;
`;
const FilterOption = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 8px;
  align-items: flex-start;
`;

const OptionItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  width: calc(100% / 2);
  border-radius: 4px;
  gap: 8px;
  color: #616161;
`;
